import request from '@/utils/request'

const fetchKYCInfo = () => {
  return request({
    path: '/merchants/kyc-info',
    method: 'GET',
  })
}

const verifyCRNumber = () => {
  return request(
    {
      path: '/merchants/kyc-doc',
      method: 'POST',
      data: {},
    },
    {
      options: { hideMessage: true, disableErrorRedirect: true },
    }
  )
}

export { fetchKYCInfo, verifyCRNumber }
